import { Box } from "@mui/material";
import { ParagraphText } from "../../../Libraries";
import "./styles.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const AppAmountChip = ({ data = [], handleChip, chipActiveIndex, disabled = false }) => {
  return (
    <Box className="appAmountChipWrapper">
      {data.map((item, index) => (
        <ParagraphText
          tabIndex={disabled ? -1 : 0}
          key={index}
          className={`appAmountChipInner ${
            chipActiveIndex === index ? "active" : ""
          }${disabled ? " disabled" : ""}`}
          onClick={() => { if (disabled) return; triggerLogEvent(analytics, "amount_chip_selected", { label: item?.label }); handleChip(index, item); }}
          onKeyDown={(e) => {
            if (disabled) return;
            if (e.key === "Enter" && !e.shiftKey) { triggerLogEvent(analytics, "amount_chip_selected", { label: item?.label }); handleChip(index, item); }
          }}
        >
          {item.label}
        </ParagraphText>
      ))}
    </Box>
  );
};

export default AppAmountChip;
